const collectValidIndexKeys = (docs, userId, academicYear, semester, isValidReviewIndex) => {
  const indexedOfferingKeys = new Set();
  let indexCount = 0;
  docs.forEach((indexDoc) => {
    if (isValidReviewIndex(indexDoc.data(), indexDoc.id, userId, academicYear, semester)) {
      indexedOfferingKeys.add(indexDoc.id);
      indexCount += 1;
    }
  });
  return { indexCount, indexedOfferingKeys };
};

const selectRepairCourses = (courses, indexedOfferingKeys, getOfferingKey) => {
  const selected = [];
  const selectedOfferingKeys = new Set();
  for (const course of courses) {
    const offeringKey = getOfferingKey(course);
    if (indexedOfferingKeys.has(offeringKey) || selectedOfferingKeys.has(offeringKey)) continue;
    selectedOfferingKeys.add(offeringKey);
    selected.push({ course, offeringKey });
  }
  return selected;
};

module.exports = { collectValidIndexKeys, selectRepairCourses };
